export const starColors = {
  'chonky.500': {
    bg: '#44D0EF',
    border: '#30BCDB',
    accent: '#20D7F4',
  },
  'venasaur.500': {
    bg: '#05BBB5',
    border: '#0B9C97',
    accent: '#69D6D3',
  },
  'spyro.500': {
    bg: '#6F59BE',
    border: '#573FA1',
    accent: '#8d73e0',
  },
  'kirby.500': {
    bg: '#FF3364',
    border: '#D02951',
    accent: '#FF5C83',
  },
  'bandicoot.500': {
    bg: '#FF665C',
    border: '#E55047',
    accent: '#FFA39D',
  },
  'samus.500': {
    bg: '#FFCE2C',
    border: '#FFAE14',
    accent: '#f8dfaf',
  },
  'luigisPants.300': {
    bg: '#597196',
    border: '#294874',
    accent: '#8D9FB7',
  },
}
